import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import _noop from "lodash/noop";

export const Icon = ({ id, className, onClick = _noop }) => (
  <svg className={classNames("icon", className)} onClick={onClick}>
    <use xlinkHref={`#${id}`} />
  </svg>
);

Icon.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/Common/Icon.js